import React from 'react';

/* Desktop-only banner illustration. Sized by height (not width), so it renders at a fixed,
   consistent size regardless of viewport width — only the flat bannerBase fill to its left
   grows or shrinks. Left edge is mask-faded so it blends into that base color seamlessly. */
export default function BannerScene({ src, alt = '', isMobile = false }) {
  const fadeMask = 'linear-gradient(to right, transparent 0%, transparent 15%, rgba(0,0,0,0.4) 35%, #000 60%)';

  return (
    <img
      src={src}
      alt={alt}
      aria-hidden={alt === ''}
      style={{
        position: 'absolute',
        right: isMobile ? '-15%' : 0, // Shift to the right on mobile
        bottom: 0,
        height: '100%',
        width: 'auto',
        maxWidth: 'none',
        objectFit: 'contain',
        objectPosition: 'bottom right',
        pointerEvents: 'none',
        opacity: isMobile ? 0.75 : 1, 
        WebkitMaskImage: fadeMask,
        maskImage: fadeMask,
      }}
    />
  );
}
